import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useClipsStore } from "./ClipsStore/clipsStore";

export const UserDropDownFrontel = ({
  navBarCollapsed,
}: {
  navBarCollapsed: boolean;
}) => {
  const {
    groupOptionsFrontel,
    userDropDownValueFrontel,
    setUserDropDownValueFrontel,
    setCameraDropDownValueFrontel,
    setGroupIDFrontel,
    setFrontelUsername,
    setSiteDropDownValueFrontel,
    setSiteOptionsFrontel,
    setUserFiltersFrontel,
    setCameraOptionsFrontel,
    loadingGroupsFrontel,
    getAllSitesFrontel,
  } = useClipsStore();
  const navigate = useNavigate();
  // Create a Set to track unique names and ensure we only add each name once
  const uniqueNames = new Set<string>();
  const options: string[] = [];

  const optionGroupIds = new Map();
  const optionUsernames = new Map();
  // First pass: collect unique names and their corresponding IDs and usernames.
  // Credentials can have group=null (SET_NULL on group delete) — skip them,
  // matching UserDropDownAILink, instead of crashing the whole Clips page.
  (groupOptionsFrontel || []).forEach((object: any) => {
    if (object.group && !uniqueNames.has(object.group.name)) {
      uniqueNames.add(object.group.name);
      options.push(object.group.name);
      optionGroupIds.set(object.group.name, object.group.id);
      optionUsernames.set(object.group.name, object.username);
    }
  });

  return (
    <div key="user_dropdown_frontel">
      <Autocomplete
        value={userDropDownValueFrontel}
        disablePortal
        options={options}
        onChange={(event, value: any) => {
          if (value !== null) {
            setUserDropDownValueFrontel(value);
            setCameraDropDownValueFrontel(null);
            setGroupIDFrontel(optionGroupIds.get(value));
            setFrontelUsername(optionUsernames.get(value));
            setSiteDropDownValueFrontel(null);
            setSiteOptionsFrontel([]);
            getAllSitesFrontel(optionGroupIds.get(value), navigate);
            setUserFiltersFrontel((previousState: any) => {
              return {
                ...previousState,
                user: optionUsernames.get(value),
                site_ids: [],
                camera_ids: [],
              };
            });
          } else {
            setUserDropDownValueFrontel(value);
            setSiteDropDownValueFrontel(null);
            setSiteOptionsFrontel([]);
            setCameraDropDownValueFrontel(null);
            setCameraOptionsFrontel([]);
            setFrontelUsername("");
            setUserFiltersFrontel((previousState: any) => {
              return {
                ...previousState,
                user: "",
                site_ids: [],
                camera_ids: [],
              };
            });
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Group"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loadingGroupsFrontel ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
            autoComplete="off"
            helperText="*Required"
            sx={!navBarCollapsed ? { width: 150 } : { width: 175 }}
          />
        )}
      />
    </div>
  );
};
